<template>
  <div>
    <br>
      <menu-admin />
           <div class="grid-responsive">
            <div class="row">
                <div class="col-md-4">
                  <div class="card">
              <div class="card-body">
                <h5 class="card-title">Valor total dos serviços</h5>
                R$ {{valorServico}}
              </div>
            </div>
                </div>
                <div class="col-md-4">
                  <div class="card">
              <div class="card-body">
                <h5 class="card-title">Lucro bruto</h5>
                R$ {{lucro}}
              </div>
            </div>
                </div>
            </div>              
           </div>
  </div>
</template>

<style scoped>
 
</style>

<script>
 
import MenuAdmin from "@/components/MenuAdmin.vue";

import {AdminService} from "@/http"
import {formatPrice} from "@/utils"


export default {
   components:{
       MenuAdmin
   }, 
   data:()=>{
     return {
         valorServico:0, 
          lucro:0,
     }
   }, 
   created(){
        
        AdminService.DashBoard().then((response)=>{
             
           const {lucro,valorServico}= response.data
           
            this.valorServico = formatPrice(valorServico / 100)

            const l = (0.1 * (lucro / 100))
            this.lucro = formatPrice(l)
          
        }).catch((error)=>{
             window.console.log("Aqui-<<",error.response)
        })
   }
   
}
</script>
 
